import { FileText, Server } from "lucide-react";
import type { HttpFacts } from "../../../../lib/siteScan";
import type { T } from "../types";
import { Field, Panel } from "./primitives";

/** The transport facts: status, server, TLS hygiene and the redirect chain. */
export function TransportPanel({ http, t }: { http: HttpFacts; t: T }) {
  return (
    <Panel icon={Server} title={t("scanner.http.title")}>
      <dl className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        <Field label={t("scanner.http.status")} value={http.status == null ? "-" : String(http.status)} />
        <Field label={t("scanner.http.server")} value={http.server ?? "-"} mono />
        <Field label={t("scanner.http.poweredBy")} value={http.poweredBy ?? "-"} mono />
        <Field label={t("scanner.http.ip")} value={http.ipAddress ?? "-"} mono />
        <Field label={t("scanner.http.hsts")} value={t(http.hsts ? "common.yes" : "common.no")} />
        <Field
          label={t("scanner.http.httpsRedirect")}
          value={http.httpsRedirect == null ? "-" : t(http.httpsRedirect ? "common.yes" : "common.no")}
        />
        <Field label={t("scanner.http.contentType")} value={http.contentType?.split(";")[0] ?? "-"} mono />
        <Field label={t("scanner.http.total")} value={http.totalMs == null ? "-" : `${http.totalMs} ms`} />
      </dl>

      {http.redirects.length > 0 && (
        <div className="mt-3 border-t border-[var(--crm-hair)] pt-3">
          <p className="mb-1.5 flex items-center gap-1.5 text-[11px] font-medium text-muted-foreground">
            <FileText className="size-3" /> {t("scanner.http.redirects", { count: http.redirects.length })}
          </p>
          {/* Keyed by position, not by URL: a browser-side hop can revisit an
              address the chain already passed through. */}
          <ol className="space-y-0.5">
            {http.redirects.map((hop, i) => (
              <li key={`${i}-${hop.url}`} className="break-all font-mono text-[11px] text-muted-foreground">
                <span className="crm-tnum mr-1.5 rounded bg-[var(--crm-sunk)] px-1">
                  {hop.kind === "meta" ? t("scanner.http.hopMeta") : hop.status}
                </span>
                {hop.url}
              </li>
            ))}
          </ol>
        </div>
      )}
    </Panel>
  );
}
